import { render, staticRenderFns } from "./TermsOfUseFooter.vue?vue&type=template&id=6d61fcaa&scoped=true"
import script from "./TermsOfUseFooter.vue?vue&type=script&lang=js"
export * from "./TermsOfUseFooter.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseFooter.vue?vue&type=style&index=0&id=6d61fcaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61fcaa",
  null
  
)

export default component.exports